import React, { useState, useRef, useEffect } from 'react'
import { Chevron } from '../../elements/Chevron'
import { Text } from '../../elements/Text'
import { IProps } from './index'
import { BrandOptions, useBrand } from 'marketing-site/src/library/providers/brandProvider/'
import { DropDown as DropDownDefault } from './component'
import styles from './styles.scss'

function childOf(
  child: (Node & ParentNode) | null | undefined,
  parent: (Node & ParentNode) | null | undefined,
) {
  while ((child = child?.parentNode) && child !== parent);
  return !!child
}

export const DropDown = (props: IProps) => {
  const theme = useBrand()
  if (theme === BrandOptions.default) {
    return <DropDownDefault {...props} />
  }
  return <DropDownLegacy {...props} />
}

function DropDownLegacy({ label, openerClassNames, children }: IProps) {
  const ref = useRef<HTMLDivElement | null>(null)
  const [active, setActive] = useState<boolean>(false)

  function toggleMenu() {
    setActive((active) => !active)
  }

  function handleItemKeyDown(event: React.KeyboardEvent<HTMLElement>) {
    if (event.key === 'ArrowDown') {
      event.preventDefault()
      setActive(true)
    }
  }

  useEffect(() => {
    function onDocumentClick(e: MouseEvent) {
      if (ref.current && !childOf(e.target as Node & ParentNode, ref.current)) setActive(false)
    }
    document.addEventListener('click', onDocumentClick)
    return () => document.removeEventListener('click', onDocumentClick)
  }, [])

  return (
    <div className="dropdown__wrap" ref={ref}>
      <button
        type="button"
        onClick={toggleMenu}
        onKeyDown={handleItemKeyDown}
        aria-haspopup="listbox"
        aria-expanded={active}
        className={`dropdown__opener ${openerClassNames ?? ''}`}
      >
        <Text size="md+">{label}</Text>
        <span className="dropdown__opener-chevron">
          <Chevron />
        </span>
      </button>

      {active ? (
        <div className="dropdown__content">
          <div className="dropdown__content-inner">{children}</div>
        </div>
      ) : null}
      <style jsx>{styles}</style>
    </div>
  )
}
